// "This cycle in review" - the rule-based analyst card. Theme-aware throughout.
import { colors, fonts } from './UI'

function rgba(hex, a) {
  const n = parseInt(hex.slice(1), 16)
  return `rgba(${(n >> 16) & 255},${(n >> 8) & 255},${n & 255},${a})`
}

export default function CycleReview({ review, cycleLabel }) {
  if (!review) return null
  const toneColor = t => (t === 'good' ? colors.green : t === 'warn' ? colors.red : colors.gold)

  return (
    <div style={{ background: colors.card, border: `1px solid ${colors.borderGold}`, borderRadius: '16px', boxShadow: `0 8px 24px rgba(0,0,0,0.32), 0 0 24px ${colors.cardGlow}`, backdropFilter: colors.cardBlur, WebkitBackdropFilter: colors.cardBlur, overflow: 'hidden', marginBottom: '14px' }}>

      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 18px 12px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '9px' }}>
          <div style={{ width: '34px', height: '34px', borderRadius: '9px', background: rgba(colors.gold, 0.14), display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '17px' }}>📊</div>
          <span style={{ fontFamily: fonts.heading, fontSize: '14px', fontWeight: 700, letterSpacing: '0.09em', color: colors.text }}>THIS PERIOD IN REVIEW</span>
        </div>
        {cycleLabel && <span style={{ fontSize: '11px', fontWeight: 600, color: `rgba(${colors.textRgb},0.5)` }}>{cycleLabel}</span>}
      </div>

      {/* Headline */}
      <div style={{ padding: '0 18px 4px' }}>
        <p style={{ fontSize: '14px', lineHeight: 1.55, color: colors.text, margin: '0 0 14px' }}>{review.headline}</p>
      </div>

      {/* Callouts */}
      <div style={{ padding: '0 18px 6px', display: 'flex', flexDirection: 'column', gap: '9px' }}>
        {review.callouts.map((c, i) => {
          const col = toneColor(c.tone)
          return (
            <div key={i} style={{ display: 'flex', gap: '11px', alignItems: 'flex-start', padding: '11px 13px', background: rgba(col, 0.07), border: `1px solid ${rgba(col, 0.18)}`, borderRadius: '11px' }}>
              <span style={{ fontSize: '15px', lineHeight: 1.4 }}>{c.icon}</span>
              <div style={{ fontSize: '13px', lineHeight: 1.5, color: colors.text }}>{c.text}</div>
            </div>
          )
        })}
      </div>

      <div style={{ height: '14px' }} />
    </div>
  )
}
